/**
 * @fileoverview
 * Decides whether a Blockly workspace event changes the project, so the parent frame gets the latest one.
 */

/**
 * @param {object} event Blockly workspace event.
 * @return {boolean} true if the event changes the project the VM saves.
 */
export const isProjectChangeEvent = event => {
    // Field value edits (e.g. a number in a block) are `change` events that carry a blockId.
    if (event.type === 'change') return true;
    return Boolean(event.oldCoordinate || event.oldXml || (!event.blockId && event.newValue));
};
